<template>
    <div class="pg-integral-log">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">積分管理</div>
            <div class="breadcrumb-item">積分日誌(舊)</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline">
				<FormItem>
				    <Select size="small" placeholder="提貨櫃點" v-model="form.remarks">
				        <Option :value="item.ReceivingName" v-for="(item, index) in shopList" :key="item.ReceivingName">({{item.cainiao_match}}) {{item.ReceivingName}}</Option>
				    </Select>
				</FormItem>
                <FormItem>
                    <Select size="small" style="width: 120px;" placeholder="積分變動類型" v-model="form.type">
                        <Option :value="1">充值</Option>
                        <Option :value="2">贈送</Option>
                        <Option :value="3">消費</Option>
                    </Select>
                </FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" clearable
								@on-change="changeStartDate"
                                placeholder="操作起始日期" format="yyyy-MM-dd HH:mm:ss" style='width: 100%;'></DatePicker>
                </FormItem>
                <FormItem>-</FormItem>
                <FormItem>
                    <DatePicker class="no-suffix" type="datetime" size="small" clearable
								@on-change="changeEndDate"
                                placeholder="操作結束日期" format="yyyy-MM-dd HH:mm:ss" style='width: 100%;'></DatePicker>
                </FormItem>
            </Form>

            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <label class="input-label">客戶名稱</label>
                    <Input size="small" v-model="form.username" @keyup.enter.native="handleSearch()"/>
                </FormItem>
                <FormItem>
                    <label class="input-label">手機號碼</label>
                    <Input size="small" v-model="form.phone" @keyup.enter.native="handleSearch()"/>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style1" @click="handleSearch()">搜索</div>
                        <div class="pg-btn style2" @click="handleExport()">導出excel</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
			<Spin fix class="pg-sub-loading" v-if="isSubmiting">
			    <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
			    <div class="loading-text">Loading</div>
			</Spin>
            <Table size="small"
				   no-data-text="暫無數據"
                   border
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="type">
                    <!-- 1充值，2赠送，3消费 -->
                    <span v-if="row.type == 1">充值</span>
                    <span v-else-if="row.type == 2">贈送</span>
                    <span v-else-if="row.type == 3">消費</span>
                </template>
            </Table>

            <div class="pg-pagger"  v-if="totalCount > table.data.length" >
                <Row>
                    <Col span="12" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="12" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    </div>
</template>

<script>
	import Store from '../../../assets/js/store.js'
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码
				// items:Store.fetch(),
                isSubmiting: false,
                shopList: [],    //使用门店

                form: {
                    type: '',    //积分变动类型, 1充值 2赠送 3消费
                    start_time: '',
                    end_time: '',
                    remarks: '', //使用门店id
					// article_id: '',
                    username: '',   //客户名称
                    phone: ''  //手机号
                },

                table: {
                    column: [
                        {
                            title: '客戶名稱',
                            key: 'user_name',
                            align: 'center',
							sortable: true,
                            width: 130
                        },
                        {
                            title: '聯絡電話',
                            key: 'phone',
                            align: 'center',
							sortable: true,
                            width: 120
                        },
                        {
                            title: '門店人員',
                            key: 'remarks',
                            align: 'center',
							sortable: true,
                            width: 100
                        },
						{
						    title: '快遞單號',
						    key: 'odd_numbers',
						    align: 'center',
							sortable: true,
						    width: 100
						},
                        {
                            title: '積分變動',
                            key: 'type',    //类型1充值2赠送3消费
                            align: 'center',
                            slot: 'type',
							sortable: true,
                            width: 130
                        },
                        {
                            title: '充值積分',
                            key: 'integral',  //类型1充值2赠送3消费
                            align: 'center',
							sortable: true,
                            width: 100
                        },
                        /*{
                            title: '贈送積分',
                            key: 'zsIntegral',
                            align: 'center',
                            width: 100
                        },*/
                        {
                            title: '操作時間',
                            key: 'created_at',
                            align: 'center',
							sortable: true,
                            width: 160
                        },
                        {
                            title: '操作詳情',
                            key: 'describe',
                            align: 'center',
							sortable: true
                        }
                    ],
                    data: []
                }
            };
        },
        mounted()
        {
            this.getShopList();
            
        },
        methods: {
			changeStartDate(e) {
				this.form.start_time = e;
			},
			changeEndDate(e) {
				this.form.end_time = e;
			},
            //获取使用门店
            getShopList()
            {
                this.$Rq.requestAuth({
                    url: this.$Api.pickAddress,
                    method: 'get',
                    data: {
                        company_id: 1,
                        type: 1    //type 1門店， 2是智能櫃
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.shopList = res.data.data;
						if (res.data.data.length <= 1) {
							this.form.remarks = res.data.data[0].ReceivingName;
						}
						this.getList();
                    }
                });
            },
			
            getList()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.integralLog,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize,
                        type: form.type,
                        start_time: form.start_time,
                        end_time: form.end_time,
                        article_id: form.article_id,
						remarks: form.remarks,
                        username: form.username,
                        phone: form.phone
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                user_name: resData[i].user? resData[i].user.user_name: '',
                                phone: resData[i].user? resData[i].user.phone: '',
                                type: resData[i].type, //1充值 2贈送 3消費
                                integral: resData[i].integral,
                                created_at: resData[i].created_at,
                                describe: resData[i].describe,
								remarks: resData[i].remarks == "" ? resData[i].user.cabinet_name : resData[i].remarks,
								odd_numbers: resData[i].odd_numbers
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    } else
                    {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleSearch()
            {
                this.pageIndex = 1;
                this.getList();
            },
            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },
            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },
            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
			},
			handleExport() {
                
			    let token = localStorage.getItem('jyb_token');
			    let form = this.form;
			    let params = {
			        'Authorization': token,
					offset: (this.pageIndex - 1) * this.curPageSize,
					limit: this.curPageSize,
					type: form.type,
					start_time: this.$Utils.formatDate(form.start_time),
					end_time: this.$Utils.formatDate(form.end_time),
					remarks: form.remarks,
					username: form.username,
					phone: form.phone
			    };
			    let formatParams = this.$Utils.formateObjToParamStr(params);
				
				if(form.start_time == ''){
					this.$Utils.showTipInfo("請選擇起始時間");
				}
				else if(form.end_time == ''){
					this.$Utils.showTipInfo("請選擇結束時間");
				}
				else{
                    this.getList();
					window.open(`${this.$Api.integralLogExport}?${formatParams}`, '_blank');
					// this.exportLink = `${this.$Api.deliverFexport}?${formatParams}`;
				}
			}
        }
    };
</script>

<style lang="scss" scoped>
    @import 'IntegralLog.scss';
</style>